// @flow strict
import { Button, Divider, Modal } from 'antd';
import { useState } from 'react';
import { HiMiniEye } from "react-icons/hi2";
import ReferredUserList from './ReferredUserList';

function SingleReferer({ item }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button icon={<HiMiniEye />} className='btn-success' onClick={() => setIsModalOpen(true)}>
        Referred Users
      </Button>
      <Modal
        title={<h5>{"Referred users of " + item?.referer?.fname + " " + item?.referer?.lname}</h5>}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[]}
      >
        <Divider />
        <ReferredUserList users={item?.users} />
      </Modal>
    </>
  );
};

export default SingleReferer;